export var componentsLocales = {
  closeButtonAriaLabel: 'Close notification'
};